import { apiClient } from './client'
import { getStoredRole } from '../../utils/token'
import type { DashboardReport } from '../../types/dashboard'

function base(path: string): string {
  const isAdmin = getStoredRole() === 'admin'
  return isAdmin ? `/administrator/dashboard/${path}` : `/dashboard/${path}`
}

function qs(params?: { date_from?: string; date_to?: string }): string {
  if (!params) return ''
  const q = new URLSearchParams()
  if (params.date_from) q.append('date_from', params.date_from)
  if (params.date_to) q.append('date_to', params.date_to)
  const s = q.toString()
  return s ? `?${s}` : ''
}

export const dashboardApi = {
  getCampaignReport(
    campaignId: number,
    params?: { date_from?: string; date_to?: string }
  ): Promise<DashboardReport> {
    return apiClient.get(`${base(`campaigns/${campaignId}/report`)}${qs(params)}`, {
      skipRoleRouting: true,
    })
  },

  getAdUnitReport(
    campaignId: number,
    adUnitId: number,
    params?: { date_from?: string; date_to?: string }
  ): Promise<DashboardReport> {
    return apiClient.get(
      `${base(`campaigns/${campaignId}/ad_units/${adUnitId}/report`)}${qs(params)}`,
      { skipRoleRouting: true }
    )
  },
}
